import { render, staticRenderFns } from "./CompanyMenuWorkerFoodOrderDialog.vue?vue&type=template&id=168894d2"
import script from "./CompanyMenuWorkerFoodOrderDialog.vue?vue&type=script&lang=js"
export * from "./CompanyMenuWorkerFoodOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports